import defaultAxios from 'axios'

export const TOKEN_AUTH = 'rest-auth/token-auth'
export const TOKEN_VERIFY = 'rest-auth/token-verify'
export const TOKEN_REFRESH = 'rest-auth/token-refresh'
export const RESET_PASSWORD = 'rest-auth/password/reset/'
export const LOGOUT_ALL = 'accounts/logout_all'
export const REQUEST_PHONE_VERIFICATION = 'api/sndle/1.2/request_phone_verification'
export const CHECK_PHONE_VERIFICATION = 'api/sndle/1.2/check_phone_verification'
export const CREATE_ACCOUNT = 'api/sndle/1.0/create_account'
export const CHAT_TOKEN_AUTH = 'rest_auth/login'
export const CREATE_PROFILE_AUTO_MESSAGE = 'twilio/2.1/create_profile_auto_message'
export const CREATE_GROUP_AUTO_MESSAGE = 'twilio/2.1/create_group_auto_message'
export const CREATE_CATEGORY_AUTO_MESSAGE = 'twilio/2.1/create_category_auto_message'
export const CREATE_INTEREST_AUTO_MESSAGE = 'twilio/2.1/create_interest_auto_message'
export const UPDATE_PROFILE_AUTO_MESSAGE = 'twilio/2.1/update_profile_auto_message'
export const UPDATE_GROUP_AUTO_MESSAGE = 'twilio/2.1/update_group_auto_message'
export const UPDATE_CATEGORY_AUTO_MESSAGE = 'twilio/2.1/update_category_auto_message'
export const UPDATE_INTEREST_AUTO_MESSAGE = 'twilio/2.1/update_interest_auto_message'
export const DELETE_AUTO_MESSAGE = 'twilio/2.1/delete_auto_message'

// TODO: handle 401 globally
// See here: https://github.com/axios/axios/issues/690
export const mainAxios = defaultAxios.create({
  baseURL: process.env.VUE_APP_SNDLE_BACKEND_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

export const chatAxios = defaultAxios.create({
  baseURL: process.env.VUE_APP_MESSAGE_SERVER_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

export const twilioAxios = defaultAxios.create({
  baseURL: 'https://api.twilio.com',
  headers: {
    'Content-Type': 'application/json'
  }
})
